import Component from '../core/Component';
import Flickity from "flickity";

export default class Carousel extends Component {
    prepare() {
        this.flickity()
    }

    flickity() {
        const element = this.element
        let options = {
            draggable: ">1",
            cellAlign: "center",
            pageDots: false,
            groupCells: true,
            resize: true,
            arrowShape:
                "M15.8734116,52.802184 L22.4469334,59.5766087 C22.9778446,60.139055 22.9778446,61.0167182 22.4469334,61.5791646 L20.5297735,63.5845291 C20.2811869,63.8495774 19.9336203,64 19.569786,64 C19.2059516,64 18.8583851,63.8495774 18.6097984,63.5845291 L6.39459027,50.9709548 C5.86846991,50.4044596 5.86846991,49.5292768 6.39459027,48.9627816 L18.5309725,36.4194231 C18.7782625,36.1520644 19.1263118,36 19.49096,36 C19.8556082,36 20.2036576,36.1520644 20.4509476,36.4194231 L22.3709227,38.4247877 C22.9036037,38.9876167 22.9036037,39.8673232 22.3709227,40.4301522 L15.7974009,47.2017682 L94.595206,47.2017682 C94.968009,47.2010206 95.3257587,47.348439 95.5893707,47.611435 C95.8529828,47.8744311 96.0007465,48.2313447 95.9999972,48.6032765 L95.9999972,51.4006757 C95.9984483,52.1740664 95.3704083,52.8006388 94.595206,52.802184 L15.8734116,52.802184 Z"
        }

        if (window.matchMedia("(max-width: 767px)").matches) {
            options.pageDots = true
        } 

        this.flickity = new Flickity(element, options);

        this.flickity.on("select", () => {
            if (this.flickity.selectedIndex == this.flickity.cells.length - 1) {
                this.element.classList.add('end')
            } else {
                this.element.classList.remove("end");
            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/Carousel.js